import { render, staticRenderFns } from "./VDataTableCustomHeader.vue?vue&type=template&id=25e1d1f6&scoped=true"
import script from "./VDataTableCustomHeader.vue?vue&type=script&lang=js"
export * from "./VDataTableCustomHeader.vue?vue&type=script&lang=js"
import style0 from "./VDataTableCustomHeader.vue?vue&type=style&index=0&id=25e1d1f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1d1f6",
  null
  
)

export default component.exports